// What a card looks like on the phone (docs/phone-plan.md): its thumbnail,
// the band redrawn over the scan's banner, and how tall tiles are.
// Copied from hutchies/imperium src/imperium/ui/phone/face.js and adapted:
// STCC's suits, its official scans, and traits in the band (the band covers
// the scan's trait icons; the skill bars show below it).
import { get } from 'svelte/store';
import { prefs } from '../stores.js';
import { hasOfficialImage, officialImage, getNewIcon } from '../card_images.js';
import { currentTraits } from '../parse.js';
import { CARD_RATIO } from './phone.js';

// The scan's name, or null for a card drawn by NewCardImage.
export function faceImage(c, facedown = false){
    if(facedown) return 'back';
    if(!c || !get(prefs).useCardImages || !hasOfficialImage(c)) return null;
    if(c.savedTraits || c.savedValues || c.savedTypeGains) return null; // as CardImage: changed cards are drawn
    return officialImage(c);
}
export const thumbURL = name => `cards/thumb/${name}.webp`;
export const scanURL = name => `cards/${name}.png`;

// Darker than getSuitColor, so white type reads on them.
const COLOURS = {
    location: '#2b7a35', person: '#a87908', cargo: '#004a8c', ship: '#5f6773', ally: '#7b2d8e',
    captain: '#3f5f74', incident: '#b3261e', encounter: '#8e4f91', mission: '#3b4250', directive: '#64603a', qsuit: '#b0126b'
};
export const bandColour = c => COLOURS[c?.suits?.[0]] ?? '#3b4250';

// The band: suit icon, the name, then trait icons (as many as fit).
export function band(c, max = 3){
    if(!c) return { name: '', suit: null, traits: [] };
    let suit = c.suits?.[0] ? getNewIcon(c.suits[0]) : null;
    let traits = [...new Set(currentTraits(c) || [])].slice(0, max).map(t => getNewIcon(t));
    return { name: c.name ?? '', suit, traits };
}

// How tall tiles are: as tall as lets every card fit, between the tile (band
// and the top of the scan) and the whole card; below that the area scrolls.
// `rows` is the number of rows the zones need at `cols` across.
export function tileSize({ width, height, rows, cols, gap = 4, fixed = 0 }){
    const w = Math.floor((width - (cols - 1) * gap) / cols);
    const tile = Math.round(w * 0.40), whole = Math.round(w * CARD_RATIO);
    const fit = Math.floor((height - fixed - Math.max(0, rows - 1) * gap) / Math.max(1, rows));
    return { w, h: Math.max(tile, Math.min(whole, fit)), tile, whole };
}
